package util

import kotlinx.browser.window

val availableWidth get() = window.screen.availWidth